import { render } from "./KeseluruhanKodAkaun.vue?vue&type=template&id=4145ccda"
import script from "./KeseluruhanKodAkaun.vue?vue&type=script&lang=js"
export * from "./KeseluruhanKodAkaun.vue?vue&type=script&lang=js"

import "./KeseluruhanKodAkaun.vue?vue&type=style&index=0&id=4145ccda&lang=css"
import "./KeseluruhanKodAkaun.vue?vue&type=style&index=1&id=4145ccda&lang=css"

import exportComponent from "/var/www/html/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__